import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import CarouselImage1 from "../../assets/images/states/AndhraPradeshRed.webp";
import CarouselImage2 from "../../assets/images/states/GujaratRed_cropped.jpg";
import CarouselImage3 from "../../assets/images/states/KarnatakaRed_cropped.jpg";
import CarouselImage4 from "../../assets/images/states/KeralaRed_cropped.jpg";
import CarouselImage5 from "../../assets/images/states/MadhyaPradeshRed_cropped.jpg";
import CarouselImage6 from "../../assets/images/states/MaharashtraRed _cropped.jpg";
import CarouselImage7 from "../../assets/images/states/TamilNaduRed_cropped.jpg";
// import CarouselImage8 from "../../assets/images/states/MaharashtraRed-removebg-preview.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  filterProductsApiOldVersion,
  filterProductsApi,
} from "../features/productSlice";

const Carousel = () => {
  const [positionIndexes, setPositionIndexes] = useState([0, 1, 2, 3, 4, 5, 6]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const images = [
    CarouselImage1,
    CarouselImage2,
    CarouselImage3,
    CarouselImage4,
    CarouselImage5,
    CarouselImage6,
    CarouselImage7,
  ];

  const stateNames = [
    "Andhra Pradesh",
    "Gujarat",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Tamil Nadu",
  ];

  const handleStateClick = (index) => {
    const stateName = stateNames[index];
    // dispatch(filterProductsApiOldVersion({ state: stateName }));
    dispatch(filterProductsApi({ location: stateName }));
    navigate(`/view-all?types=${stateName}`);
  };

  const handleDotClick = (index) => {
    // Calculate the new position indexes array where the clicked index will be at center (position 3)
    const newPositions = Array(7)
      .fill(0)
      .map((_, i) => {
        // Calculate relative position from the clicked index
        let newPos = (i - index + 3) % 7;
        // Handle negative numbers
        if (newPos < 0) newPos += 7;
        return newPos;
      });

    setPositionIndexes(newPositions);
  };

  const handleNext = () => {
    setPositionIndexes((prevIndexes) => {
      return prevIndexes.map((prevIndex) => (prevIndex - 1 + 7) % 7);
    });
  };

  const handleBack = () => {
    setPositionIndexes((prevIndexes) => {
      return prevIndexes.map((prevIndex) => (prevIndex + 1) % 7);
    });
  };

  const positions = [
    "hiddenLeftTwo", // -2 position
    "hiddenLeft", // -1 position
    "left", // left of center
    "center", // center position
    "right", // right of center
    "hiddenRight", // +1 position
    "hiddenRightTwo", // +2 position
  ];

  const imageVariants = {
    center: {
      x: "0%",
      scale: 1,
      zIndex: 50,
      rotateY: 0,
      opacity: 1,
    },
    left: {
      x: "-40%",
      scale: 0.75,
      zIndex: 30,
      rotateY: 10,
      opacity: 0.8,
    },
    right: {
      x: "40%",
      scale: 0.75,
      zIndex: 30,
      rotateY: -10,
      opacity: 0.8,
    },
    hiddenLeft: {
      x: "-70%",
      scale: 0.6,
      zIndex: 20,
      rotateY: 20,
      opacity: 0.6,
    },
    hiddenRight: {
      x: "70%",
      scale: 0.6,
      zIndex: 20,
      rotateY: -20,
      opacity: 0.6,
    },
    hiddenLeftTwo: {
      x: "-95%",
      scale: 0.4,
      zIndex: 10,
      rotateY: 30,
      opacity: 0.4,
    },
    hiddenRightTwo: {
      x: "95%",
      scale: 0.4,
      zIndex: 10,
      rotateY: -30,
      opacity: 0.4,
    },
  };

  useEffect(() => {
    const interval = setInterval(handleNext, 2500);
    return () => clearInterval(interval);
  }, [positionIndexes]);

  const getResponsiveDimensions = () => {
    const width = window.innerWidth;
    if (width < 480) {
      // Extra Small Mobile
      return {
        containerHeight: "171px",
        centerImageWidth: "148px",
        sideImageWidth: "100px",
        imageHeight: "148px",
        titleFontSize: "16px",
        subtitleFontSize: "12px",
      };
    } else if (width < 576) {
      // Mobile
      return {
        containerHeight: "203px",
        centerImageWidth: "172px",
        sideImageWidth: "112px",
        imageHeight: "179px",
        titleFontSize: "18px",
        subtitleFontSize: "14px",
      };
    } else if (width < 768) {
      // Tablet
      return {
        containerHeight: "238px",
        centerImageWidth: "207px",
        sideImageWidth: "136px",
        imageHeight: "209px",
        titleFontSize: "21px",
        subtitleFontSize: "16px",
      };
    } else if (width < 992) {
      // Small Desktop
      return {
        containerHeight: "286px",
        centerImageWidth: "279px",
        sideImageWidth: "160px",
        imageHeight: "262px",
        titleFontSize: "23px",
        subtitleFontSize: "17px",
      };
    } else {
      // Large Desktop
      return {
        containerHeight: "387px",
        centerImageWidth: "362px",
        sideImageWidth: "362px",
        imageHeight: "357px",
        titleFontSize: "24px",
        subtitleFontSize: "17px",
      };
    }
  };

  // Add window resize listener
  useEffect(() => {
    const handleResize = () => {
      // Force re-render on window resize
      setPositionIndexes([...positionIndexes]);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [positionIndexes]);

  return (
    <div className="container-fluid px-2 px-sm-3 px-md-4" >
      <div
        className="row text-center "
        style={{ marginTop: window.innerWidth < 576 ? "25px" : "50px" }}
      >
        <div className="col-12">
          <h2
            className="title"
            style={{
              fontSize:
                window.innerWidth < 576
                  ? "19px"
                  : window.innerWidth < 768
                  ? "22px"
                  : "27px",
              lineHeight: 1.3,
            }}
          >
            Savor the Flavor,{" "}
            <span style={{ color: "#3c3260" }}>Delivered Anywhere!</span>
          </h2>
          <p
            className="lead mt-1"
            style={{
              fontSize:
                window.innerWidth < 576
                  ? "12px"
                  : window.innerWidth < 768
                  ? "14px"
                  : "15px",
              marginBottom: window.innerWidth < 576 ? "8px" : "17px",
            }}
          >
            Freshly Packed, Perfectly Delivered, Anytime You Crave
          </p>
        </div>
      </div>

      {/* Add padding-bottom to account for navigation dots */}
      <div className="container-fluid" style={{ paddingBottom: "34px", backgroundColor: "rgb(240 248 250)" }}>
        <div
          className="d-flex flex-column align-items-center justify-content-center bg-white   mx-auto position-relative"
          style={{
            height: getResponsiveDimensions().containerHeight,
            width: "100%",
            maxWidth: "1400px",
            overflow: "hidden",
            backgroundColor: "rgb(240 248 250)",
          }}
        >
          {images.map((image, index) => (
            <motion.div
              key={index}
              style={{
                position: "absolute",
                width: "100%",
                height: "750px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgb(240 248 250)",
              }}
            >
              <motion.img
                src={image}
                alt={stateNames[index]}
                className="img-fluid rounded shadow-lg"
                initial="center"
                animate={positions[positionIndexes[index]]}
                variants={imageVariants}
                transition={{
                  type: "spring",
                  stiffness: 200,
                  damping: 25,
                  mass: 1,
                  duration: 0.8,
                  opacity: { duration: 0.4 },
                  ease: "easeInOut",
                }}
                onClick={() => handleStateClick(index)}
                style={{
                  cursor: "pointer",
                  width:
                    positions[positionIndexes[index]] === "center"
                      ? getResponsiveDimensions().centerImageWidth
                      : getResponsiveDimensions().sideImageWidth,
                  position: "absolute",
                  backgroundColor: "#fff",
                  height: getResponsiveDimensions().imageHeight,
                  objectFit: "cover",
                  transformOrigin: "center center",
                  filter:
                    positions[positionIndexes[index]] === "center"
                      ? "brightness(1)"
                      : "brightness(0.7)",
                  // boxShadow:
                  //   positions[positionIndexes[index]] === "center"
                  //     ? "0 10px 30px rgba(0,0,0,0.2)"
                  //     : "0 5px 15px rgba(0,0,0,0.1)",
                }}
              />
            </motion.div>
          ))}
        </div>

        {/* Navigation Dots */}
        <div
          className="d-flex gap-2 justify-content-center mt-3"
          style={{
            position: "relative",
            zIndex: 60,
          }}
        >
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className="btn p-0"
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                border: "none",
                backgroundColor:
                  positionIndexes.indexOf(3) === index ? "#3c3260" : "#E1BEE7",
                transition: "all 0.3s ease",
              }}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* State Names List */}
        <div className="d-flex flex-wrap justify-content-center gap-2 gap-sm-3 mt-4">
          {stateNames.map((state, index) => (
            <button
              key={index}
              onClick={() => handleStateClick(index)}
              className="btn"
              style={{
                border: "none",
                background:
                  positionIndexes.indexOf(3) === index
                    ? "#3c3260"
                    : "rgba(74, 20, 140, 0.1)",
                color:
                  positionIndexes.indexOf(3) === index ? "#fff" : "#3c3260",
                fontWeight:
                  positionIndexes.indexOf(3) === index ? "600" : "400",
                fontSize: window.innerWidth < 576 ? "14px" : "16px",
                transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                padding: "8px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                boxShadow:
                  positionIndexes.indexOf(3) === index
                    ? "0 8px 25px rgba(74, 20, 140, 0.25)"
                    : "0 4px 12px rgba(74, 20, 140, 0.1)",
                backdropFilter: "blur(5px)",
                transform:
                  positionIndexes.indexOf(3) === index
                    ? "translateY(-5px) scale(1.05)"
                    : "translateY(0) scale(1)",
                letterSpacing:
                  positionIndexes.indexOf(3) === index ? "0.8px" : "0.5px",
                opacity: positionIndexes.indexOf(3) === index ? "1" : "0.85",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent)",
                  transform:
                    positionIndexes.indexOf(3) === index
                      ? "translateX(100%)"
                      : "translateX(-100%)",
                  transition: "transform 0.6s ease",
                }}
              />
              {state}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;